import React, { Component } from "react";
import { Layout, Button, Col, Row, Space, Typography, List, message, Card } from "antd";
import { EyeOutlined, EditFilled, FilePdfOutlined } from "@ant-design/icons";
import ModalXML from "../../Syncfy/ModalXML";
import ModalFacturas from "../../Finanzas/Facturas/ModalFacturas";

import { RenderTagTipoComprobanteFactura } from "../../../Utils";
import FloatingButton from "../../../Widgets/Floating Button/FloatingButton";

import '../../../../Styles/Modules/ManagerInventarios/ManagerInventarios.css'
import DrawerFactura from "../../../Widgets/DrawerFactura/DrawerFactura";

const { Content } = Layout;
const { Text } = Typography
const axios = require('axios')
const moment = require('moment')

/**
 * @export
 * @class NotasCreditoList
 * @extends {Component}
 * @description Vista de Notas de Crédito
 */
export default class NotasCreditoList extends Component {


    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            modalFacturasVisible: false,
            factura_id: undefined,
            factura_xml_storage: undefined,
            drawerFacturasVisible: false,
            ModalXMLVisible: false,
            facturas:{
                data: [],
                page: 1,
                limit: 10,
                total: 0,
            },
            cliente: {}
        }
    }

    componentDidMount = () => {
        this.getFacturas()
        if(this.props.cliente_id){
            this.getCliente()
        }
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.search != prevProps.search) {
            this.getFacturas();
        }
    }

    /**
     * @memberof NotasCreditoList
     * @method getCliente
     * @description Obtiene la información del cliente
     */
    getCliente = () => {
        axios.get('/clientes/get', {
            params: {
                id: this.props.cliente_id,
            }
        }).then(response => {
            this.setState({ 
                cliente: response.data.data,
            })
        }).catch(error => {
            console.log("error", error);

        })
    }

    /**
    * @memberof NotasCreditoList
    * @method   renderViews
    * @description  Renderiza los botones de las acciones
    **/
    renderViews = (item) => {


        return <Space>
            <Button
                size="small"
                type="primary"
                icon={<EditFilled />}
                title="Editar"
                onClick={() => { this.setState({ modalFacturasVisible: true, factura_id: item._id }) }}
            />
            <Button
                size="small"
                type="primary"
                icon={<EyeOutlined style={{ color: "#fff" }} />}
                onClick={(e) => this.setState({ factura_xml_storage: item.factura_xml, ModalXMLVisible: true })}
                title="Ver XML"
                disabled={!item.factura_xml}
            >
            </Button>
            <Button
                size="small"
                type="primary"
                icon={<FilePdfOutlined style={{ color: "currentColor" }} />}
                onClick={() => window.open(`${axios.defaults.baseURL}/facturas/cfdi?factura_id=${item._id}&Authorization=${sessionStorage.getItem("token")}`, '_blank')}
                title="Ver PDF"
                disabled={!(item.tipo_facturacion === 1)}
            />
        </Space>
    }


    /**
    * @memberof NotasCreditoList
    * @method   getFacturas
    * @description  Obtiene las notas de crédito del cliente
    **/
    getFacturas = ({
        page = this.state.facturas.page,
        limit = this.state.facturas.limit,
    } = this.state) => {

        let search = this.props.search
        const { cliente_id } = this.props

        this.setState({loading: true})
        axios.get('/notas-credito', {
            params: {
                page: page,
                limit: limit,
                cliente_id: cliente_id,
                search
            }
        })
        .then(({ data }) => {
            console.log('notas credito data', data);
            this.setState({
                facturas: data,
            })
        })
        .catch(error => {
            message.error("No se obtuvieron las notas de crédito")
            console.log(error)
        }).finally(()=>this.setState({loading: false}))
    }


    render() {

        return (
            <>
                <Content>
                    <Row>
                        <Col span={24}>
                            <List
                                className="component-list lista-vmi"
                                locale={{ emptyText: "Sin Notas de Crédito" }}
                                itemLayout="horizontal"
                                dataSource={this.state.facturas.data}
                                loading={this.state.loading}
                                pagination={{
                                    current: this.state.facturas.page,
                                    pageSize: this.state.facturas.limit,
                                    total: this.state.facturas.total,
                                    hideOnSinglePage: false,
                                    position: 'bottom',
                                    className: "flex-left",
                                    onChange: (page, limit) => this.getFacturas({page, limit})
                                }}
                                header={<Row className="header-list width-100 pl-1 pr-1 ">
                                    <Col span={5} className="center">
                                        <Text strong>Fecha</Text>
                                    </Col>
                                    <Col span={5} className="center">
                                        <Text strong>Tipo</Text>
                                    </Col>
                                    <Col span={5} className=" center">
                                        <Text strong>Folio</Text>
                                    </Col>
                                    <Col span={5} className="center">
                                        <Text strong>Monto</Text>
                                    </Col>
                                    
                                </Row>}
                                renderItem={item => (
                                    <List.Item className="component-list-item">
                                        <Card className="card-list">
                                            <Row className="width-100 ">
                                                <Col lg={5} className="center">
                                                    <Text ellipsis strong>{moment(item.fecha).format('DD-MM-YYYY')}</Text>
                                                </Col>
                                                <Col lg={5} className="center">
                                                    <Text ellipsis>{RenderTagTipoComprobanteFactura(item.tipo_comprobante)}</Text>
                                                </Col>
                                                <Col span={5} className="center">
                                                    <p style={{ width: '100%' }}>
                                                        <strong>{item.serie}-{item.folio}</strong><br />
                                                        <small>{item?.receptor?.rfc}</small>
                                                    </p>
                                                </Col>
                                                <Col lg={5} className="center">
                                                    <Text ellipsis>$ {item.monto ? item.monto.toMoney(true) : '0.00'} <small>{item.moneda}</small></Text>
                                                </Col>
                                                <Col lg={4} className="center">
                                                    {this.renderViews(item)}
                                                </Col>
                                            </Row>
                                        </Card>
                                    </List.Item>
                                )}
                            />

                        </Col>
                    </Row>
                </Content>
                <FloatingButton title="Nuevo registro" onClick={() => this.setState({ drawerFacturasVisible: true })} />

                <DrawerFactura
                    visible={this.state.drawerFacturasVisible}
                    onClose={(update) => {
                        this.setState({ drawerFacturasVisible: false, factura_id: undefined })
                        if (update === true) {
                            this.getFacturas()
                        }
                    }}
                    clienteId={this.props.cliente_id}
                    cliente={this.state.cliente}
                />

                <ModalXML
                    visible={this.state.ModalXMLVisible}
                    onCancel={() => this.setState({ ModalXMLVisible: false, factura_xml_storage: undefined, xml: undefined })}
                    factura_xml_storage={this.state.factura_xml_storage}
                />

                <ModalFacturas
                    visible={this.state.modalFacturasVisible}
                    onClose={() => {
                        this.setState({ modalFacturasVisible: false, factura_id: undefined })
                        this.getFacturas()
                    }}
                    factura_id={this.state.factura_id}
                />
            </>
        )
    }
}